/**
 * Created by jonas on 2022-01-11.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {BS2} from "../BS2";
import {BS2Sound} from "../config/sound/BS2Sound";
import {BS2GameAssets} from "../BS2GameAssets";
import {BitmapText} from "pixi.js";
import {DemonCircles} from "./parts/DemonCircles";
import {HotFrame} from "./parts/HotFrame";
import {BS2GameMode} from "../server/BS2GameMode";

export class BS2TransitionScreenView extends PIXI.Container implements StageLayer {
    protected button: ContinueButton;
    private clickCallback?: Function;
    private _background: PIXI.Sprite;
    private _introSprite: PIXI.Sprite;
    private _introSpine: PIXI.spine.Spine;
    private _introSpinsLeft: BitmapText;
    private _youWonAmount: BitmapText;
    private _spinsPlayedNumber: BitmapText;
    private _circleAnimation: DemonCircles;
    private _outroTextScreen: PIXI.Container;
    private _hotFrame: HotFrame;
    private _youWonText: PIXI.Text;


    constructor(name?: string) {
        super();
        this.name = name ? name : "BS2TransitionScreenView";
        this.init();
    }

    onResize(): void {
        if (NolimitApplication.isLandscape) {
            this.button.position.set(360, 610);
        } else {
            if (BS2.model.data.nextMode === BS2GameMode.NORMAL) {
                const centerBottom: number = (NolimitApplication.screenBounds.bottom - 610) * 0.5 + 610;
                this.button.position.set(360, centerBottom - 80);
            } else {
                this.button.position.set(360, NolimitApplication.screenBounds.bottom - 170);
            }
        }

        this._hotFrame.resize();
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
    }

    public enableButton(cb: Function): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this.button.enable(true);
        });
        tl.add(gsap.to(this.button, {duration: 0.2, alpha: 1}));
        return tl;
    }

    public showIntro(soundLoopCb?: () => void): gsap.core.Timeline {
        const spinsLeft: string = BS2.model.data.freespinsLeft.toString();
        this._background.alpha = 0;
        this._introSprite.visible = true;
        this._introSprite.alpha = 0;
        // this._introSpine.visible = true;
        // this._introSpine.alpha = 0;
        this._introSpinsLeft.text = spinsLeft;
        this._introSpinsLeft.alpha = 0;
        this._introSpinsLeft.visible = true;
        this._introSpinsLeft.pivot.set(this._introSpinsLeft.width / 2, this._introSpinsLeft.height / 2);

        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.onResize();
            this.visible = true;
        });
        tl.add(gsap.to(this._background, {duration: 0.2, alpha: 0.5, ease: "none"}));
        tl.add(() => {
            BS2.soundPlayer.fadeOutMusic(500);
            BS2.soundPlayer.playSound(BS2Sound.FS_WIN);
        });
        tl.add(gsap.to(this._introSprite, {duration: 0.3, alpha: 1, ease: "none"}));
        // tl.add(() => {
        //
        //     // this._introSpine.alpha = 1;
        //     // this._introSpine.updateTransform();
        // });


        // tl.add(SpineGSAPWrapper.createTimeline(this._introSpine, 0, "start"));
        tl.add(gsap.to(this._introSpinsLeft, {duration: 0.3, alpha: 1, ease: "none"}), "<");
        // tl.add(SpineGSAPWrapper.createTimeline(this._introSpine, 0, "loop", -1));

        if (soundLoopCb) {
            // tl.add(SpineGSAPWrapper.createTimeline(this._introSpine, 1, "heart_loop", -1), "<");
            tl.add(() => {
                // BS2.soundPlayer.playSound(BS2Sound.SFS_HEART);
                soundLoopCb();
            }, "<");
        }

        return tl;

    }

    public hideIntro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add([
            gsap.to(this._background, {duration: 1.0, alpha: 0.0, ease: "none"}),
            gsap.to(this._introSprite, {duration: 0.5, alpha: 0.0, ease: "none"}),
            // gsap.to(this._introSpine, {duration: 0.5, alpha: 0.0, ease: "none"}),
            gsap.to(this._introSpinsLeft, {duration: 0.5, alpha: 0.0, ease: "none"}),
        ], "<");

        tl.add(() => {
            this._introSpinsLeft.text = "";
            this._introSpinsLeft.visible = false;
            // this._introSpine.state.clearTracks();
            // this._introSpine.state.setEmptyAnimation(0, 0);
        });

        return tl;
    }

    public showMaxWin(): gsap.core.Timeline {
        this._background.alpha = 0;
        this._introSprite.alpha = 0;
        this._introSprite.visible = false;
        // this._introSpine.alpha = 0;
        // this._introSpine.visible = false;
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.onResize();
            this.visible = true;
        });
        return tl;
    }

    public hideMaxWin(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.visible = false;
        });
        return tl;
    }

    public showOutro(amount: number, spinsPlayed: number): gsap.core.Timeline {
        this._background.alpha = 0;
        this._introSprite.alpha = 0;
        this._introSprite.visible = false;
        // this._introSpine.alpha = 0;
        // this._introSpine.visible = false;

        this._outroTextScreen.alpha = 0;
        this._outroTextScreen.visible = true;

        if (BS2.isWinBelowStake() || (BS2.model.data.accumulatedRoundWin == 0)) {
            this._youWonText.visible = false;

        } else {
            this._youWonText.visible = true;
        }
        this._spinsPlayedNumber.text = spinsPlayed.toString();
        this._youWonAmount.text = BS2.apiPlugin.currency.formatValue(amount);

        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.onResize();
            this.visible = true;
        });


        tl.add(gsap.to(this._outroTextScreen, {
            duration: 0.5,
            alpha: 1,
            ease: "none"
        }));
        tl.add(this._circleAnimation.show(0.5), "<");
        tl.add(this._hotFrame.show(0.5), "<");
        tl.add(gsap.to(this._background, {duration: 0, alpha: 0.5, ease: "none"}), "<");

        return tl;
    }

    public hideOutro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this._outroTextScreen, {
            duration: 0.5,
            alpha: 0,
            ease: "none"
        }));
        tl.add(this._circleAnimation.hide(0.5), "<");
        tl.add(this._hotFrame.hide(0.5), "<");
        tl.add(gsap.to(this._background, {duration: 0.5, alpha: 0, ease: "none"}), "<");
        return tl;
    }


    public createOutroTextScreen(): PIXI.Container {
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            "dropShadow": true,
            "dropShadowAngle": -89.7,
            "dropShadowBlur": 1,
            "fill": [
                "#ff2c27",
                "#ff321d",
                "#ff321d"
            ],
            "fontFamily": "Helvetica",
            "fontSize": 51,
            "fontWeight": "900",
            "miterLimit": 1,
            "strokeThickness": 10
        });

        const container: PIXI.Container = new PIXI.Container();
        container.name = "outroTextScreen";
        const youWonContainer: PIXI.Container = new PIXI.Container();
        youWonContainer.name = "youWonContainer";
        const youWonBg: PIXI.Sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.OUTRO_INK_STREAK)[0]);
        youWonBg.name = "youWonBg";
        youWonBg.anchor.set(0.5, 0.5);
        youWonBg.position.set(0, 70);
        youWonBg.scale.set(1.0, 1.5);

        this._youWonText = new PIXI.Text(BS2.apiPlugin.translations.translate("YOU WON"), textStyle);
        this._youWonText.name = "youWonText";
        this._youWonText.anchor.set(0.5, 0.5);

        this._youWonAmount = new PIXI.BitmapText("", {
            fontName: BS2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 150,
        });
        this._youWonAmount.anchor = new PIXI.Point(0.5, 0.5);
        this._youWonAmount.position.set(0, 60);

        youWonContainer.addChild(youWonBg);
        youWonContainer.addChild(this._youWonText);
        youWonContainer.addChild(this._youWonAmount);


        const spinsPlayedContainer: PIXI.Container = new PIXI.Container();
        spinsPlayedContainer.name = "spinsPlayedContainer";
        const spinsPlayedBg: PIXI.Sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.OUTRO_INK_STREAK)[0]);
        spinsPlayedBg.name = "spinsPlayedBg";
        spinsPlayedBg.anchor.set(0.5, 0.5);
        spinsPlayedBg.position.set(0, 70);
        spinsPlayedBg.scale.set(1.0, 1.5);

        const spinsPlayedText: PIXI.Text = new PIXI.Text(BS2.apiPlugin.translations.translate("SPINS PLAYED"), textStyle);
        spinsPlayedText.name = "spinsPlayedText";
        spinsPlayedText.anchor.set(0.5, 0.5);

        this._spinsPlayedNumber = new PIXI.BitmapText("", {
            fontName: BS2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 150,
        });
        this._spinsPlayedNumber.name = "spinsPlayedNumber";
        this._spinsPlayedNumber.anchor = new PIXI.Point(0.5, 0.5);
        this._spinsPlayedNumber.position.set(0, 70);

        spinsPlayedContainer.addChild(spinsPlayedBg);
        spinsPlayedContainer.addChild(spinsPlayedText);
        spinsPlayedContainer.addChild(this._spinsPlayedNumber);


        youWonContainer.position.set(0, -130);
        spinsPlayedContainer.position.set(0, 70);
        spinsPlayedContainer.scale.set(0.5, 0.5);


        container.addChild(youWonContainer)
        container.addChild(spinsPlayedContainer)

        return container;
    }

    protected init() {

        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.name = "backgroundSprite";
        this._background.tint = PIXI.utils.string2hex("#000000");
        this._background.position.set(360, 360);
        this._background.anchor.set(0.5, 0.5);

        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());
        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;

        this._introSprite = new PIXI.Sprite(BS2.assetLoader.getTextures("FS_Intro/SFS-intro")[0]);
        this._introSprite.name = "introSprite";
        this._introSprite.position.set(360, 342);
        this._introSprite.visible = false;
        this._introSprite.alpha = 0;
        this._introSprite.anchor.set(0.5, 0.5);
        this._introSprite.scale.set(0.72, 0.72);

        // this._introSpine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.FS_INTRO_SPINE));
        // this._introSpine.name = "introSpine";
        // this._introSpine.position.set(360);
        // this._introSpine.visible = false;
        // this._introSpine.alpha = 0;

        this._introSpinsLeft = new PIXI.BitmapText("", {
            fontName: BS2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 160,
        });
        this._introSpinsLeft.name = ""
        this._introSpinsLeft.visible = false;
        this._introSpinsLeft.position.set(360, 450);

        this._introSpinsLeft.pivot.set(this._introSpinsLeft.width / 2, this._introSpinsLeft.height / 2);


        this._circleAnimation = new DemonCircles();
        this._circleAnimation.position.set(360, 360);
        this._outroTextScreen = this.createOutroTextScreen();
        this._outroTextScreen.position.set(360, 360);
        this._outroTextScreen.visible = false;

        this._hotFrame = new HotFrame();
        this._hotFrame.position.set(360, 360);
        this._hotFrame.hide(0);


        this.addChild(this._background);
        this.addChild(this._introSprite);
        // this.addChild(this._introSpine);
        this.addChild(this._introSpinsLeft);
        this.addChild(this._hotFrame);
        this.addChild(this._circleAnimation);
        this.addChild(this._outroTextScreen);
        this.addChild(this.button);
        this.visible = false;

    }

    private onButtonClick() {
        this.button.enable(false);
        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        BS2.soundPlayer.playSound(BS2Sound.CONTINUE_BUTTON);
        gsap.to(this.button, {duration: 0.2, alpha: 0});
        delete this.clickCallback;
    }

}